import React, { Component } from "react";
import { connect } from "react-redux";
import Axios from "axios";
import "./style.css";
import { configuration } from "../appConfig";
import { Spinner } from "reactstrap";
import Lightbox from "react-image-lightbox";
import dashboardErrorImg from "../../src/assets/img/brand/dashboard-error-logo.png"
import Swal from "sweetalert2";


const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export class PreDamage93SVGDentTable extends Component {
  PreDamage = React.createRef(null);
  state = {
    data: {},
    words: {},
    lang: "",
    vin: "",
    loading: false,
    imageSrc: "",
    captureImageName: "",
    extraImageNameArr: [],
    extraImageNameArr_1: [],
    partIndex: "",
    isLightBoxOpen : false,
    isEditLoading : false,
    clickedPartName : ""
  };
  componentDidMount() {

    // const partnerId = localStorage.getItem("partnerId");
    // const vin = localStorage.getItem("selectedFile");
    // Axios.get(
    //   `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
    // ).then((r) => {
    //   if (r.data) {
    //     this.setState({ data: r.data });
    //   }
    // });
    setTimeout(() => {
      
      this.setState({ data: this.props.data });
    }, 500);
    // this.getData()
    this.getLang();
    // this.getPreDamageImages();
  }
  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({
        words: res.data,
        lang: localStorage.getItem("lang"),
      });
    });
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }
  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };
  getData = () =>{
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    Axios.get(
      `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
    ).then((r) => {
      if (r.data) {
        this.setState({ data: r.data });
      }
    });
  }
  getBase644 = async (file) => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async function () {
        resolve(reader.result);
      };
      reader.onerror = function (error) {
        reject(error);
      };
    });
  };
  capture = async (e) => {
    // if (e.target.files.length > 0) {
    //   this.setState(
    //     {
    //       imageSrc: e.target.files[0],
    //     },
    //     () => {
    //       this.props.uploadExtraImagesNew(this.state.imageSrc, this.state.captureImageName, this);
    //     }
    //   );
    // }
    const { files } = e.target;
    const base64 = await this.getBase644(files[0]);
    this.setState(
      {
        imageSrc: base64,
      },
      () => {
        this.props.uploadExtraImagesNew(
          this.state.imageSrc,
          this.state.captureImageName,
          this
        );
        this.setState({isLightBoxOpen : false})

      }
    );
  };
  userClick = (part, i) => {
    if (this.props.authorized) {
      Toast.fire({
        type: "error",
        title: this.lang("ThisVINisAuthorized"),
      });
      return
    }
    this.setState({ partIndex: i });
    this.setState({
      captureImageName: part,
      imageSrc: "",
    });
    if (!this.fillColor(part)) {
      this.PreDamage.click();
    }
  };
  fillColor = (part) => {
    const { extraImageNameArr_1 } = this.props;
    let partimages = extraImageNameArr_1.filter(
      (item) => item.includes(part) && item.split(".")[0].length === part.length
    );
    if (partimages[0]) {
      return "#EF3D3C";
    }
  };
  openImage =(clickedName)=>{
    const {extraNewImages} = this.props
    const findName = extraNewImages && extraNewImages.length > 0 && extraNewImages.find((partName)=>{
      return partName.part == clickedName
    }) 
    this.setState({
      clickedPartName : findName.name,
      isLightBoxOpen: !this.state.isLightBoxOpen,
      captureImageName : clickedName,
      clickedImageObj : findName
    })
  }
  handleRetake = ()=>{
    this.PreDamage.click();
  }
  handleDelete = async ()=>{
    await this.props.handleDelete(this.state.clickedImageObj)
    await this.setState({isLightBoxOpen: false})

  }

  handlerotate = ()=>{
    const partName = this.state.clickedImageObj.name.split("/")[this.state.clickedImageObj.name.split("/").length -1]
    this.props.handlerotate(partName)
  }
  render() {
    const partnerId = localStorage.getItem("partnerId")
    const vin = localStorage.getItem("selectedFile")
    const { extraNewImages, allOtherPartImages,isDeleteLoading,isRotateLoading } = this.props;
    const { isLightBoxOpen,captureImageName,isEditLoading,clickedPartName } = this.state;
    const filterArr = extraNewImages.filter((ele) =>
      allOtherPartImages.includes(ele.part)
    );
    let toolbarButtons = [];

    toolbarButtons = [
      <>
        <div className="photo_app_image_lightbox_wrapper">
          <button
            onClick={() => this.setState({ isLightBoxOpen: !isLightBoxOpen })}
          >
            <i className="fa fa-check"></i>

          </button>
          <button
          disabled={this.props.authorized}
          onClick={() => this.handleRetake()}>
            <i className="fa fa-camera"></i>
          </button>
          {/* <button onClick={() => this.toggleEdit()}>
            {isEditLoading ? <Spinner /> : <i className="fa fa-pencil"></i>}
          </button> */}
          <button
          disabled={this.props.authorized}
          onClick={() => this.handlerotate()}>
            {isRotateLoading ? <Spinner style={{ height: '1rem', width: '1rem' }} /> : <i className="fa fa-repeat"></i>}
            {/* <i className="fa fa-repeat"></i> */}
          </button>
          <button
          disabled={this.props.authorized}
          onClick={() => this.handleDelete()}>
            {isDeleteLoading ? <Spinner style={{ height: '1rem', width: '1rem' }} /> : <i className="fa fa-trash"></i>}
          </button>
        </div>
      </>,
    ];
    return (
      <>
        <input
          type="file"
          name="image"
          id="file"
          // ref="PreDamage"
          ref={(input) => (this.PreDamage = input)}
          accept="image/*"
          capture="environment"
          style={{ display: "none" }}
          onChange={(e) => this.capture(e)}
        />
        <div className="row p-0 car_svg_table text-muted hide-report">
          <div className="table-responsive mb-3 svg_scroll_table">
            <table className="table table-bordered table-striped dent-table-2d text-center">
              <thead>
                <tr>
                  <th className="sr_col">{this.lang("Sr. No")}</th>
                  <th className="text-left">
                    {this.lang("Damage Description")}
                  </th>
                  <th className="action_col">{this.lang("Action")}</th>
                </tr>
              </thead>
              <tbody>
                {allOtherPartImages.map((r, i) => {
                  const parts = r.split("_");
                  const [first, ...rest] = parts;
                  const combinedRest = rest.join("_");
                  const name = [first, combinedRest];

                  const hasImages = filterArr.some((img) => img.part === r);
                  return (
                    <tr
                      key={i}
                      className={
                        hasImages ? "active-images-row" : "deactive-images-row"
                      }
                    >
                      <td className="sr_col">{i + 1}</td>
                      <td className="text-left">{this.lang(name[1])}</td>
                      <td className="action_col">
                        {hasImages === true ? (
                          <i className="fa fa-eye" onClick={()=> this.openImage(r)}></i>
                        ) : this.state.partIndex === i ? (
                          this.props.loading ? (
                            <Spinner style={{ height: '1rem', width: '1rem' }} size="sm" />
                          ) : (
                            <i
                              className="fa fa-camera"
                              onClick={() => this.userClick(r, i)}
                            ></i>
                          )
                        ) : (
                          <i
                            className="fa fa-camera"
                            onClick={() => this.userClick(r, i)}
                          ></i>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {
          isLightBoxOpen && 
          <>
          <Lightbox
            className="photoapp_lightbox_main"
            reactModalStyle={{
              overlay: { zIndex: 100000000 },
              content: {},
            }}
            toolbarButtons={toolbarButtons}
            mainSrc={
             `${clickedPartName}?${Date.now()}`
            }

            onCloseRequest={() =>
              this.setState({
                isLightBoxOpen: false,
              })
            }

            onImageLoadError={(...events) => { console.log(events) }}

            imageLoadErrorMessage={
              <img
                style={{ height: "100%", width: "100%" }}
                src={dashboardErrorImg}
              />
            }
          />
          </>
        }
      </>
    );
  }
}
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(PreDamage93SVGDentTable);
